import React, {
    useMemo,
    useState
} from 'react';

import {
    useDispatch,
    useSelector
} from 'react-redux';

import Swal from 'sweetalert2';

import useConfigAuth
    from '../../../Hooks/useConfigAuth';

import {
    crearPacienteAction
} from '../../../actions/crearPacienteActions';

import SelectorUbicacion
    from '../../Metodos/Compartidos/Ubicacion/SelectorUbicacion';

import {

    FormularioPaciente,
    TarjetaFicha,

    BannerObligatorios,
    BannerTitulo,
    BannerDetalle,

    BloqueFicha,
    EncabezadoSeccion,
    FilaTituloSeccion,
    TituloSeccion,
    TextoSeccion,

    GridFormulario,
    CampoFormulario,
    LabelFormulario,
    Obligatorio,
    InputFormulario,
    SelectFormulario,
    TextoError,

    SeparadorSeccion,

    CabeceraTutores,
    SubtituloDomicilio,

    AccionesFormulario,
    BotonGuardarPaciente,
    BotonAyudaFormulario

} from '../../Css/StyledNuevoPaciente';


/*
========================================
ESTADO INICIAL
========================================
*/

const FORMULARIO_INICIAL = {

    /*
    ====================================
    PACIENTE
    ====================================
    */

    nombre: '',
    apellido: '',
    sexo: '',
    fecha_nacimiento: '',
    email: '',

    nacionalidad: '',


    /*
    ====================================
    UBICACIÓN LEGACY
    ====================================

    Estos campos se mantienen por ahora
    para no romper otras partes antiguas
    del sistema.

    La ubicación nueva se guarda en:
    ubicacion / ubicacion_1 / ubicacion_2.
    */

    pais: '',
    provincia: '',
    departamento: '',
    localidad: '',

    direccion: '',


    /*
    ====================================
    ESCOLARIDAD
    ====================================
    */

    dni: '',
    colegio: '',
    curso: '',
    repitio_anio: '',


    /*
    ====================================
    COBERTURA
    ====================================
    */

    cobertura_medica: '',
    plan: '',
    numero_afiliado: '',


    /*
    ====================================
    INFORMACIÓN CLÍNICA
    ====================================
    */

    medico: '',
    medicacion: '',
    diagnostico_previo: '',
    motivo_consulta: '',
    terapias_actuales: '',
    hermanos: '',


    /*
    ====================================
    TUTOR 1
    ====================================
    */

    nombre_1: '',
    apellido_1: '',
    fecha_nacimiento_1: '',
    email_1: '',
    telefono_1: '',

    pais_1: '',
    provincia_1: '',
    departamento_1: '',
    localidad_1: '',

    direccion_1: '',

    nivel_estudios_1: '',
    profesion_1: '',
    ocupacion_1: '',
    estado_civil_1: '',


    /*
    ====================================
    TUTOR 2
    ====================================
    */

    nombre_2: '',
    apellido_2: '',
    fecha_nacimiento_2: '',
    email_2: '',
    telefono_2: '',

    pais_2: '',
    provincia_2: '',
    departamento_2: '',
    localidad_2: '',

    direccion_2: '',

    nivel_estudios_2: '',
    profesion_2: '',
    ocupacion_2: '',
    estado_civil_2: '',


    /*
    ====================================
    OTROS
    ====================================
    */

    conocieron: ''

};


/*
========================================
OBLIGATORIOS PARA CREAR FICHA
========================================

IMPORTANTE:

Estos son únicamente los campos necesarios
para crear el paciente administrativo.

NO son los requisitos necesarios para
convertir posteriormente al paciente en
paciente definitivo de YÖGEN.
*/

const CAMPOS_OBLIGATORIOS_CREACION = [

    'nombre',
    'apellido',
    'email',
    'curso',
    'repitio_anio'

];


const ETIQUETAS_OBLIGATORIOS = {

    nombre:
        'Nombre',

    apellido:
        'Apellido',

    email:
        'Email del paciente',

    curso:
        'Curso',

    repitio_anio:
        'Repitió algún año'

};


/*
========================================
COMPONENTE
========================================
*/

const FormularioNuevoPaciente = ({
    onCreado
}) => {

    const dispatch =
        useDispatch();

    const [config] =
        useConfigAuth();


    const emailProfesional =
        useSelector(
            (state) =>
                state.usuario.email
        );


    /*
    ====================================
    FORMULARIO
    ====================================
    */

    const [
        formulario,
        setFormulario
    ] = useState(
        FORMULARIO_INICIAL
    );


    const [
        errores,
        setErrores
    ] = useState({});


    /*
    Indica que el profesional ya intentó
    crear la ficha al menos una vez.

    Antes de ese momento NO mostramos
    mensajes de error.
    */

    const [
        intentoGuardar,
        setIntentoGuardar
    ] = useState(false);


    const [
        guardando,
        setGuardando
    ] = useState(false);


    /*
    ====================================
    UBICACIONES NUEVAS
    ====================================
    */

    const [
        ubicacionPaciente,
        setUbicacionPaciente
    ] = useState({});


    const [
        ubicacionTutor1,
        setUbicacionTutor1
    ] = useState({});


    const [
        ubicacionTutor2,
        setUbicacionTutor2
    ] = useState({});


    /*
    ====================================
    CAMPOS OBLIGATORIOS FALTANTES
    ====================================

    Esto se utiliza para construir el
    banner violeta del diseño.
    */

    const faltantesObligatorios =
        useMemo(
            () => {

                return CAMPOS_OBLIGATORIOS_CREACION
                    .filter(
                        campo => {

                            return (
                                String(
                                    formulario[
                                        campo
                                    ] ?? ''
                                )
                                    .trim() === ''
                            );

                        }
                    )
                    .map(
                        campo =>
                            ETIQUETAS_OBLIGATORIOS[
                                campo
                            ]
                    );

            },
            [
                formulario
            ]
        );


    /*
    ====================================
    CAMBIAR CAMPO
    ====================================
    */

    const cambiarCampo = (
        e
    ) => {

        const {

            name,
            value

        } = e.target;


        setFormulario(
            anterior => ({

                ...anterior,

                [name]:
                    value

            })
        );


        /*
        Quitamos el error del campo
        mientras el usuario lo corrige.
        */

        setErrores(
            anteriores => {

                const nuevos = {
                    ...anteriores
                };


                delete nuevos[
                    name
                ];


                /*
                Los emails se validan entre sí.

                Si cambia uno, limpiamos los
                errores de emails para evitar
                dejar un mensaje viejo visible.
                */

                if (
                    [
                        'email',
                        'email_1',
                        'email_2'
                    ].includes(
                        name
                    )
                ) {

                    delete nuevos.email;
                    delete nuevos.email_1;
                    delete nuevos.email_2;

                }


                return nuevos;

            }
        );

    };


    /*
    ====================================
    VALIDAR FORMULARIO
    ====================================
    */

    const validarFormulario = () => {

        const nuevosErrores =
            {};


        /*
        ====================================
        OBLIGATORIOS DE CREACIÓN
        ====================================
        */

        CAMPOS_OBLIGATORIOS_CREACION
            .forEach(
                campo => {

                    if (
                        String(
                            formulario[
                                campo
                            ] ?? ''
                        )
                            .trim() === ''
                    ) {

                        nuevosErrores[
                            campo
                        ] =
                            'Falta completar este campo';

                    }

                }
            );


        /*
        ====================================
        EMAILS DUPLICADOS
        ====================================

        El email del paciente, Tutor 1,
        Tutor 2 y profesional no pueden
        coincidir entre sí.

        Los emails de los tutores siguen
        siendo opcionales.
        */

        const emails = [

            {
                campo:
                    'email_profesional',

                valor:
                    emailProfesional
                        ?.trim()
                        .toLowerCase()
            },

            {
                campo:
                    'email',

                valor:
                    formulario
                        .email
                        .trim()
                        .toLowerCase()
            },

            {
                campo:
                    'email_1',

                valor:
                    formulario
                        .email_1
                        .trim()
                        .toLowerCase()
            },

            {
                campo:
                    'email_2',

                valor:
                    formulario
                        .email_2
                        .trim()
                        .toLowerCase()
            }

        ].filter(
            item =>
                item.valor
        );


        for (
            let i = 0;
            i < emails.length;
            i++
        ) {

            for (
                let j = i + 1;
                j < emails.length;
                j++
            ) {

                if (
                    emails[
                        i
                    ].valor ===
                    emails[
                        j
                    ].valor
                ) {

                    if (
                        emails[
                            i
                        ].campo !==
                        'email_profesional'
                    ) {

                        nuevosErrores[
                            emails[
                                i
                            ].campo
                        ] =
                            'El email no puede coincidir con otro';

                    }


                    if (
                        emails[
                            j
                        ].campo !==
                        'email_profesional'
                    ) {

                        nuevosErrores[
                            emails[
                                j
                            ].campo
                        ] =
                            'El email no puede coincidir con otro';

                    }

                }

            }

        }


        setErrores(
            nuevosErrores
        );


        return (
            Object.keys(
                nuevosErrores
            ).length === 0
        );

    };


    /*
    ====================================
    AYUDA
    ====================================
    */

    const mostrarAyudaNuevoPaciente =
        () => {

            Swal.fire({

                title:
                    'Crear un nuevo paciente',

                html: `
                    <div
                        style="
                            text-align:left;
                            line-height:1.6;
                        "
                    >

                        <p>
                            <strong>
                                Para crear la ficha inicial
                                no necesitás completar todos
                                los datos.
                            </strong>
                        </p>

                        <p>
                            Los campos señalados en
                            <strong style="color:#514BBE;">
                                violeta
                            </strong>
                            son los únicos obligatorios
                            en este momento.
                        </p>

                        <p>
                            El resto de la información
                            puede completarse más adelante
                            desde la ficha del paciente.
                        </p>

                        <p>
                            Antes de habilitar al paciente
                            para utilizar YÖGEN, el sistema
                            verificará por separado que
                            estén cargados todos los datos
                            necesarios.
                        </p>

                    </div>
                `,

                icon:
                    'info',

                confirmButtonText:
                    'Entendido',

                confirmButtonColor:
                    '#655EE8'

            });

        };


    /*
    ====================================
    GUARDAR
    ====================================
    */

    const guardarPaciente =
        async (
            e
        ) => {

            e.preventDefault();


            setIntentoGuardar(
                true
            );


            if (
                !validarFormulario()
            ) {

                /*
                Después de actualizar los errores,
                desplazamos la pantalla al primero.
                */

                setTimeout(
                    () => {

                        const primerError =
                            document
                                .querySelector(
                                    '[data-error="true"]'
                                );


                        primerError
                            ?.scrollIntoView({

                                behavior:
                                    'smooth',

                                block:
                                    'center'

                            });


                        const control =
                            primerError
                                ?.querySelector(
                                    'input, select'
                                );


                        control
                            ?.focus();

                    },
                    0
                );


                return;

            }


            setGuardando(
                true
            );


            const informacion = {

                config,

                payload: {

                    /*
                    Conservamos todos los campos
                    existentes para no modificar
                    el contrato actual del backend.
                    */

                    ...formulario,


                    /*
                    ====================================
                    UBICACIÓN INTERNACIONAL NUEVA
                    ====================================
                    */

                    ubicacion:
                        ubicacionPaciente,

                    ubicacion_1:
                        ubicacionTutor1,

                    ubicacion_2:
                        ubicacionTutor2,


                    /*
                    ====================================
                    EMAILS NORMALIZADOS
                    ====================================
                    */

                    email:
                        formulario
                            .email
                            .trim(),

                    email_1:
                        formulario
                            .email_1
                            .trim(),

                    email_2:
                        formulario
                            .email_2
                            .trim(),

                    email_profesional:
                        emailProfesional

                }

            };


            const respuesta =
                await dispatch(
                    crearPacienteAction(
                        informacion
                    )
                );


            setGuardando(
                false
            );


            /*
            ====================================
            ERROR AL CREAR PACIENTE
            ====================================
            */

            if (
                !respuesta?.ok
            ) {

                await Swal.fire({

                    icon:
                        'error',

                    title:
                        'No se pudo crear el paciente',

                    text:
                        respuesta
                            ?.error
                            ?.msg ||
                        'Ocurrió un error al crear el paciente.',

                    confirmButtonText:
                        'Entendido',

                    confirmButtonColor:
                        '#655EE8'

                });


                return;

            }


            /*
            ====================================
            PACIENTE CREADO
            ====================================
            */

            if (
                onCreado
            ) {

                onCreado();

            }

        };


    /*
    ====================================
    RENDER INPUT
    ====================================

    Un único helper reemplaza la repetición
    de JSX para todos los inputs comunes.
    */

    const renderCampo = ({

        nombre,
        label,
        type = 'text',
        obligatorio = false,
        placeholder = '',
        completo = false

    }) => {

        const tieneError =
            Boolean(
                errores[
                    nombre
                ]
            );


        return (

            <CampoFormulario

                key={
                    nombre
                }

                data-error={
                    tieneError
                        ?
                        'true'
                        :
                        'false'
                }

                data-obligatorio={
                    obligatorio
                        ?
                        'true'
                        :
                        'false'
                }

                data-completo={
                    completo
                        ?
                        'true'
                        :
                        'false'
                }

            >

                <LabelFormulario
                    htmlFor={
                        nombre
                    }
                >

                    {label}


                    {
                        obligatorio && (

                            <Obligatorio>
                                *
                            </Obligatorio>

                        )
                    }

                </LabelFormulario>


                <InputFormulario

                    id={
                        nombre
                    }

                    name={
                        nombre
                    }

                    type={
                        type
                    }

                    value={
                        formulario[
                            nombre
                        ]
                    }

                    placeholder={
                        placeholder
                    }

                    aria-invalid={
                        tieneError
                    }

                    disabled={
                        guardando
                    }

                    onChange={
                        cambiarCampo
                    }

                />


                {
                    tieneError && (

                        <TextoError>

                            {
                                errores[
                                    nombre
                                ]
                            }

                        </TextoError>

                    )
                }

            </CampoFormulario>

        );

    };


    /*
    ====================================
    RENDER SELECT
    ====================================
    */

    const renderSelect = ({

        nombre,
        label,
        opciones,
        obligatorio = false

    }) => {

        const tieneError =
            Boolean(
                errores[
                    nombre
                ]
            );


        return (

            <CampoFormulario

                key={
                    nombre
                }

                data-error={
                    tieneError
                        ?
                        'true'
                        :
                        'false'
                }

                data-obligatorio={
                    obligatorio
                        ?
                        'true'
                        :
                        'false'
                }

            >

                <LabelFormulario
                    htmlFor={
                        nombre
                    }
                >

                    {label}


                    {
                        obligatorio && (

                            <Obligatorio>
                                *
                            </Obligatorio>

                        )
                    }

                </LabelFormulario>


                <SelectFormulario

                    id={
                        nombre
                    }

                    name={
                        nombre
                    }

                    value={
                        formulario[
                            nombre
                        ]
                    }

                    aria-invalid={
                        tieneError
                    }

                    disabled={
                        guardando
                    }

                    onChange={
                        cambiarCampo
                    }

                >

                    <option value="">
                        Seleccionar
                    </option>


                    {
                        opciones.map(
                            opcion => (

                                <option

                                    key={
                                        opcion.valor
                                    }

                                    value={
                                        opcion.valor
                                    }

                                >

                                    {
                                        opcion.texto
                                    }

                                </option>

                            )
                        )
                    }

                </SelectFormulario>


                {
                    tieneError && (

                        <TextoError>

                            {
                                errores[
                                    nombre
                                ]
                            }

                        </TextoError>

                    )
                }

            </CampoFormulario>

        );

    };


    /*
    ====================================
    RENDER
    ====================================
    */

    return (

        <FormularioPaciente

            onSubmit={
                guardarPaciente
            }

            noValidate

        >


            {
                intentoGuardar &&
                Object.keys(
                    errores
                ).length > 0 && (

                    <BannerObligatorios>

                        <BannerTitulo>
                            Completá o corregí los campos
                            marcados para continuar
                        </BannerTitulo>


                        <BannerDetalle>

                            {
                                faltantesObligatorios
                                    .length > 0
                                    ?
                                    `Falta: ${
                                        faltantesObligatorios
                                            .join(', ')
                                    }`
                                    :
                                    'Revisá los campos señalados.'
                            }

                        </BannerDetalle>

                    </BannerObligatorios>

                )
            }


            <TarjetaFicha>


                {/* =================================
                    DATOS DEL PACIENTE
                ================================== */}

                <BloqueFicha>


                    <EncabezadoSeccion>


                        <FilaTituloSeccion>

                            <TituloSeccion>
                                Datos del paciente
                            </TituloSeccion>


                            <BotonAyudaFormulario

                                type="button"

                                aria-label="Ayuda para crear un paciente"

                                title="¿Qué información necesito completar?"

                                onClick={
                                    mostrarAyudaNuevoPaciente
                                }

                            >
                                ?
                            </BotonAyudaFormulario>

                        </FilaTituloSeccion>


                        <TextoSeccion>

                            Los campos en violeta y
                            negrita son obligatorios.
                            El resto puede completarse
                            más adelante.

                        </TextoSeccion>

                    </EncabezadoSeccion>


                    <GridFormulario>


                        {
                            renderCampo({

                                nombre:
                                    'nombre',

                                label:
                                    'Nombre',

                                obligatorio:
                                    true

                            })
                        }


                        {
                            renderCampo({

                                nombre:
                                    'apellido',

                                label:
                                    'Apellido',

                                obligatorio:
                                    true

                            })
                        }


                        {
                            renderCampo({

                                nombre:
                                    'fecha_nacimiento',

                                label:
                                    'Fecha de nacimiento',

                                type:
                                    'date'

                            })
                        }


                        {
                            renderCampo({

                                nombre:
                                    'email',

                                label:
                                    'Email',

                                type:
                                    'email',

                                obligatorio:
                                    true

                            })
                        }


                        {
                            renderSelect({

                                nombre:
                                    'sexo',

                                label:
                                    'Sexo',

                                opciones: [

                                    {
                                        valor:
                                            'Masculino',

                                        texto:
                                            'Masculino'
                                    },

                                    {
                                        valor:
                                            'Femenino',

                                        texto:
                                            'Femenino'
                                    }

                                ]

                            })
                        }


                        {
                            renderCampo({

                                nombre:
                                    'dni',

                                label:
                                    'Documento'

                            })
                        }


                        {
                            renderCampo({

                                nombre:
                                    'nacionalidad',

                                label:
                                    'Nacionalidad'

                            })
                        }


                    </GridFormulario>


                </BloqueFicha>


                <SeparadorSeccion />


                {/* =================================
                    DOMICILIO PACIENTE
                ================================== */}

                <BloqueFicha>

                    <TituloSeccion>
                        Domicilio
                    </TituloSeccion>


                    <SelectorUbicacion

                        value={
                            ubicacionPaciente
                        }

                        onChange={
                            setUbicacionPaciente
                        }

                        prefijo="paciente"

                        disabled={
                            guardando
                        }

                    />


                    <GridFormulario>

                        {
                            renderCampo({

                                nombre:
                                    'direccion',

                                label:
                                    'Dirección',

                                completo:
                                    true

                            })
                        }

                    </GridFormulario>

                </BloqueFicha>


                <SeparadorSeccion />


                {/* =================================
                    ESCOLARIDAD
                ================================== */}

                <BloqueFicha>

                    <TituloSeccion>
                        Escolaridad
                    </TituloSeccion>


                    <GridFormulario>


                        {
                            renderCampo({

                                nombre:
                                    'colegio',

                                label:
                                    'Colegio'

                            })
                        }


                        {
                            renderCampo({

                                nombre:
                                    'curso',

                                label:
                                    'Curso / grado',

                                obligatorio:
                                    true

                            })
                        }


                        {
                            renderSelect({

                                nombre:
                                    'repitio_anio',

                                label:
                                    '¿Repitió algún año?',

                                obligatorio:
                                    true,

                                opciones: [

                                    {
                                        valor:
                                            'Si',

                                        texto:
                                            'Sí'
                                    },

                                    {
                                        valor:
                                            'No',

                                        texto:
                                            'No'
                                    }

                                ]

                            })
                        }


                    </GridFormulario>

                </BloqueFicha>


                <SeparadorSeccion />


                {/* =================================
                    COBERTURA MÉDICA
                ================================== */}

                <BloqueFicha>

                    <TituloSeccion>
                        Cobertura médica
                    </TituloSeccion>


                    <GridFormulario>


                        {
                            renderCampo({

                                nombre:
                                    'cobertura_medica',

                                label:
                                    'Obra social / cobertura'

                            })
                        }


                        {
                            renderCampo({

                                nombre:
                                    'plan',

                                label:
                                    'Plan'

                            })
                        }


                        {
                            renderCampo({

                                nombre:
                                    'numero_afiliado',

                                label:
                                    'Número de afiliado'

                            })
                        }


                    </GridFormulario>

                </BloqueFicha>


                <SeparadorSeccion />


                {/* =================================
                    INFORMACIÓN CLÍNICA
                ================================== */}

                <BloqueFicha>

                    <TituloSeccion>
                        Información clínica
                    </TituloSeccion>


                    <GridFormulario>


                        {
                            renderCampo({

                                nombre:
                                    'medico',

                                label:
                                    'Médico'

                            })
                        }


                        {
                            renderCampo({

                                nombre:
                                    'medicacion',

                                label:
                                    'Medicación'

                            })
                        }


                        {
                            renderCampo({

                                nombre:
                                    'diagnostico_previo',

                                label:
                                    'Diagnóstico previo',

                                completo:
                                    true

                            })
                        }


                        {
                            renderCampo({

                                nombre:
                                    'motivo_consulta',

                                label:
                                    'Motivo de consulta',

                                completo:
                                    true

                            })
                        }


                        {
                            renderCampo({

                                nombre:
                                    'terapias_actuales',

                                label:
                                    'Terapias actuales',

                                completo:
                                    true

                            })
                        }


                        {
                            renderCampo({

                                nombre:
                                    'hermanos',

                                label:
                                    'Hermanos',

                                completo:
                                    true

                            })
                        }


                    </GridFormulario>

                </BloqueFicha>


                <SeparadorSeccion />


                {/* =================================
                    PADRES / TUTORES
                ================================== */}

                <BloqueFicha>

                    <TituloSeccion>
                        Datos padres / tutores
                    </TituloSeccion>


                    <CabeceraTutores>

                        <span>
                            TUTOR 1
                        </span>

                        <span>
                            TUTOR 2
                        </span>

                    </CabeceraTutores>


                    <GridFormulario>


                        {
                            renderCampo({

                                nombre:
                                    'nombre_1',

                                label:
                                    'Nombre'

                            })
                        }


                        {
                            renderCampo({

                                nombre:
                                    'nombre_2',

                                label:
                                    'Nombre'

                            })
                        }


                        {
                            renderCampo({

                                nombre:
                                    'apellido_1',

                                label:
                                    'Apellido'

                            })
                        }


                        {
                            renderCampo({

                                nombre:
                                    'apellido_2',

                                label:
                                    'Apellido'

                            })
                        }


                        {
                            renderCampo({

                                nombre:
                                    'fecha_nacimiento_1',

                                label:
                                    'Fecha de nacimiento',

                                type:
                                    'date'

                            })
                        }


                        {
                            renderCampo({

                                nombre:
                                    'fecha_nacimiento_2',

                                label:
                                    'Fecha de nacimiento',

                                type:
                                    'date'

                            })
                        }


                        {
                            renderCampo({

                                nombre:
                                    'telefono_1',

                                label:
                                    'Teléfono',

                                type:
                                    'tel'

                            })
                        }


                        {
                            renderCampo({

                                nombre:
                                    'telefono_2',

                                label:
                                    'Teléfono',

                                type:
                                    'tel'

                            })
                        }


                        {
                            renderCampo({

                                nombre:
                                    'email_1',

                                label:
                                    'Email',

                                type:
                                    'email'

                            })
                        }


                        {
                            renderCampo({

                                nombre:
                                    'email_2',

                                label:
                                    'Email',

                                type:
                                    'email'

                            })
                        }


                        {
                            renderCampo({

                                nombre:
                                    'nivel_estudios_1',

                                label:
                                    'Nivel de estudios'

                            })
                        }


                        {
                            renderCampo({

                                nombre:
                                    'nivel_estudios_2',

                                label:
                                    'Nivel de estudios'

                            })
                        }


                        {
                            renderCampo({

                                nombre:
                                    'profesion_1',

                                label:
                                    'Profesión'

                            })
                        }


                        {
                            renderCampo({

                                nombre:
                                    'profesion_2',

                                label:
                                    'Profesión'

                            })
                        }


                        {
                            renderCampo({

                                nombre:
                                    'ocupacion_1',

                                label:
                                    'Ocupación'

                            })
                        }


                        {
                            renderCampo({

                                nombre:
                                    'ocupacion_2',

                                label:
                                    'Ocupación'

                            })
                        }


                        {
                            renderCampo({

                                nombre:
                                    'estado_civil_1',

                                label:
                                    'Estado civil'

                            })
                        }


                        {
                            renderCampo({

                                nombre:
                                    'estado_civil_2',

                                label:
                                    'Estado civil'

                            })
                        }


                    </GridFormulario>


                    <SubtituloDomicilio>
                        Domicilio Tutor 1
                    </SubtituloDomicilio>


                    <SelectorUbicacion

                        value={
                            ubicacionTutor1
                        }

                        onChange={
                            setUbicacionTutor1
                        }

                        prefijo="tutor1"

                        disabled={
                            guardando
                        }

                    />


                    <GridFormulario>

                        {
                            renderCampo({

                                nombre:
                                    'direccion_1',

                                label:
                                    'Dirección Tutor 1',

                                completo:
                                    true

                            })
                        }

                    </GridFormulario>


                    <SubtituloDomicilio>
                        Domicilio Tutor 2
                    </SubtituloDomicilio>


                    <SelectorUbicacion

                        value={
                            ubicacionTutor2
                        }

                        onChange={
                            setUbicacionTutor2
                        }

                        prefijo="tutor2"

                        disabled={
                            guardando
                        }

                    />


                    <GridFormulario>

                        {
                            renderCampo({

                                nombre:
                                    'direccion_2',

                                label:
                                    'Dirección Tutor 2',

                                completo:
                                    true

                            })
                        }

                    </GridFormulario>

                </BloqueFicha>


                <SeparadorSeccion />


                {/* =================================
                    CÓMO CONOCIERON YÖGEN
                ================================== */}

                <BloqueFicha>

                    <GridFormulario>

                        {
                            renderCampo({

                                nombre:
                                    'conocieron',

                                label:
                                    '¿Cómo conocieron YÖGEN?',

                                completo:
                                    true

                            })
                        }

                    </GridFormulario>

                </BloqueFicha>


            </TarjetaFicha>


            {/* =================================
                ACCIONES
            ================================== */}

            <AccionesFormulario>

                <BotonGuardarPaciente

                    type="submit"

                    disabled={
                        guardando
                    }

                >

                    {
                        guardando
                            ?
                            'Guardando...'
                            :
                            'Crear paciente'
                    }

                </BotonGuardarPaciente>

            </AccionesFormulario>


        </FormularioPaciente>

    );

};


export default FormularioNuevoPaciente;